import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';

const AppMenuCardBlueBGTwo =({activeCard,icon,title ,onClickPopup})=>{

    

 const Icon=   icon===0?<BookDown size={23}  color="rgba(86, 82, 131,0.7)" />:icon===1?<NotepadText size={23}  color="rgba(86, 82, 131,0.7)" 
        />:icon===2?<BookA size={23}  color="rgba(86, 82, 131,0.7)"  
        />:icon===3?<GalleryHorizontal size={23}   color="rgba(86, 82, 131,0.7)"  
        />:icon===4?<MonitorPlay size={23} color="rgba(86, 82, 131,0.7)" 
        />:icon===5?
       <Aperture size={23}   color="rgba(86, 82, 131,0.7)" />
       :icon===6?<Blocks size={23}  color="rgba(86, 82, 131,0.7)" />:icon===7?<CalendarCog size={23}  color="rgba(86, 82, 131,0.7)" />:icon===8?
       <TabletSmartphone size={23}   color="rgba(86, 82, 131,0.7)" />
       :icon===9?<NotebookPen size={23}  color="rgba(86, 82, 131,0.7)" />:icon===10?<BookOpenCheck size={23}  color="rgba(86, 82, 131,0.7)" />:"";
     
 const iconWhite=   icon===0?<BookDown size={23}  color="#fff" />:icon===1?<NotepadText size={23}  color="#fff" 
 />:icon===2?<BookA size={23}  color="#fff"  
 />:icon===3?<GalleryHorizontal size={23}   color="#fff"  
 />:icon===4?<MonitorPlay size={23} color="#fff" 
 />:icon===5?
 <Aperture size={23}   color="#fff" />
 :icon===6?<Blocks size={23}  color="#fff" />:icon===7?<CalendarCog size={23}  color="#fff" />:icon===8?
 <TabletSmartphone size={23}   color="#fff" />
 :icon===9?<NotebookPen size={23}  color="#fff" />:icon===10?<BookOpenCheck size={23}  color="#fff" />:"";

     const dispatch = useDispatch();
     
      
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const cardBg =activeCard?"#fff":" rgba(86, 82, 131,.8)";
      const styleCard={marginBottom:"20px",height:"60px",cursor:"pointer",border:"2px dashed "+cardBg,padding:"5px"}
      const cardBgIcon =activeCard?"rgba(86, 82, 131,0.7)":" #f9f9f9";
      const styleCardIconIcon={background:"#f1f1f1",width:"40px",height:"40px",borderRadius:"15%",
        alignContent:"center",textAlign:"center",padding:"5px"}
      return (<>
        <div   onMouseEnter={
                ()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave}  onClick={()=>onClickPopup()} align="left" className="itemCourseOuterContentMenuBlue"
 style={styleCard}> 
<div  className="contentItemCardInnergrid" ><div style={styleCardIconIcon}>{activeCard?iconWhite:Icon}</div> 

   <div  className="itemAppSettingsTopCard " style={{color:"rgba(86, 82, 131,0.7)",fontSize:"20px"}}>{title}</div>
   <div style={{
        alignContent:"center",textAlign:"center",padding:"5px"}}><ChevronRight size={23}  color={"#fff"} /></div>
  </div>
 
<div className="set-expiry-card-bottom">
<div></div>
   
   </div>   </div></>)
}
export default AppMenuCardBlueBGTwo;

